export var CardValue;
(function (CardValue) {
    CardValue["TWO"] = "2";
    CardValue["THREE"] = "3";
    CardValue["FOUR"] = "4";
    CardValue["FIVE"] = "5";
    CardValue["SIX"] = "6";
    CardValue["SEVEN"] = "7";
    CardValue["EIGHT"] = "8";
    CardValue["NINE"] = "9";
    CardValue["TEN"] = "10";
    CardValue["JACK"] = "j";
    CardValue["QUEEN"] = "q";
    CardValue["KING"] = "k";
    CardValue["ACE"] = "a";
})(CardValue || (CardValue = {}));
